<template>
  <component
    :is="as"
    class="w-full max-w-[1440px] mx-auto container-padding lg:container-padding-lg"
    :class="{ 'max-md:!w-full': fullWidthOnMobile }"
  >
    <slot/>
  </component>
</template>

<script setup lang="ts">
export type ContainerProps = {
  as?: 'div' | 'nav' | 'section' | 'article' | 'header' | 'footer' | 'main'
  fullWidthOnMobile?: boolean
}

withDefaults(defineProps<ContainerProps>(), {
  as: 'section',
  fullWidthOnMobile: false,
})
</script>
